import { useState } from 'react';
import { Play } from 'lucide-react';
import { hasEmbeddableVideo, videoUrlToThumbnail } from '../../utils/videoEmbed';
import './GalleryVideoThumbnail.css';

const MUSCLE_ACCENTS = {
  CARDIO: '#ef4444',
  METABOLICO: '#f97316',
  CORE: '#eab308',
  BRAZO: '#84cc16',
  PECHO: '#22c55e',
  ESPALDA: '#14b8a6',
  PIERNA: '#06b6d4',
  GLUTEO: '#3b82f6',
  HOMBRO: '#6366f1',
};

function accentForMuscle(group = '') {
  const key = String(group || '').trim().toUpperCase();
  return MUSCLE_ACCENTS[key] || '#64748b';
}

export default function GalleryVideoThumbnail({ url, name = '', muscleGroup = '' }) {
  const [broken, setBroken] = useState(false);
  const thumb = videoUrlToThumbnail(url);
  const playable = hasEmbeddableVideo(url);
  const showImage = thumb && !broken;
  const accent = accentForMuscle(muscleGroup);
  const initial = String(name || '?').trim().charAt(0).toUpperCase() || '?';

  return (
    <div
      className={`gallery-video-thumb${showImage ? ' gallery-video-thumb--has-image' : ''}`}
      style={!showImage ? { '--gallery-accent': accent } : undefined}
    >
      {showImage ? (
        <img
          src={thumb}
          alt=""
          className="gallery-video-thumb__img"
          loading="lazy"
          onError={() => setBroken(true)}
        />
      ) : (
        <div className="gallery-video-thumb__placeholder" aria-hidden>
          <span className="gallery-video-thumb__initial">{initial}</span>
          {muscleGroup ? (
            <span className="gallery-video-thumb__muscle">{muscleGroup}</span>
          ) : null}
        </div>
      )}
      {playable ? (
        <span className="gallery-video-thumb__play" aria-hidden>
          <Play className="gallery-video-thumb__play-icon" fill="currentColor" />
        </span>
      ) : (
        <span className="gallery-video-thumb__badge">Sin video</span>
      )}
    </div>
  );
}
